<template>
  <header class="header">
    <div class="left">后台管理系统</div>
    <div class="right">
      <button @click="logout">退出登录</button>
    </div>
  </header>
</template>

<script setup>
const logout = () => {
  localStorage.removeItem('token')
  window.location.href = '/login'
}
</script>

<style scoped>
.header {
  height: 50px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  border-bottom: 1px solid #ddd;
}
button {
  background: #f05a24;
  border: none;
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
}
button:hover {
  background: #d9480f;
}
</style>
